module.exports = __webpack_public_path__ + "static/board-01-d4e39e1385b153b98f8f42a99facab06.jpg";